


import RouteView from '../../../Routes/RouteView';
import AnnouncementNavOptions, { defaultRoute } from './AnnouncementNavOptions';


const Announcement = ({ navoption, ModalAction }) => {
    return (
        <RouteView navoption={navoption} ModalAction={ModalAction} defaultRoute={defaultRoute}>{AnnouncementNavOptions}</RouteView>
    )
}



export default Announcement